import React from 'react';
import classNames from 'classnames';
import styles from '../../styles.module.scss';
import PlaceholderAvatar from '../PlaceholderAvatar/PlaceholderAvatar';
import balonUrl from '../../assets/Balon.png';
import flechaAbajoUrl from '../../assets/flechaabajo.png';

export default function MobilePitchPlayer({
  name,
  photo,
  yellow,
  red,
  redCard2y,
  goal,
  goalCount,
  subOut,
  isHome = true,
}) {
  const avatarTeamClass = isHome
    ? styles['wca-lineaciones__m-avatar--home']
    : styles['wca-lineaciones__m-avatar--away'];

  const showYellowTop = Boolean((yellow && !redCard2y) || redCard2y);
  const showRedTopLeft = Boolean(red && !redCard2y && !yellow);
  const showRedBottomLeft = Boolean(red && !redCard2y && yellow);
  const showDiag2yBottom = Boolean(redCard2y);
  const showGoalNumber = Boolean(goal && goalCount != null && Number(goalCount) >= 2);
  const lastName = String(name || '').trim().split(/\s+/).pop();

  return (
    <div className={styles['wca-lineaciones__m-player']}>
      <div className={styles['wca-lineaciones__m-player-body']}>
        <div
          className={classNames(
            styles['wca-lineaciones__m-player-iconsCol'],
            styles['wca-lineaciones__m-player-iconsCol--left'],
          )}
        >
          <div
            className={classNames(
              styles['wca-lineaciones__m-player-iconSlot'],
              styles['wca-lineaciones__m-player-iconSlot--leftTop'],
            )}
          >
            {showYellowTop ? (
              <span
                className={classNames(
                  styles['wca-lineaciones__wc-card'],
                  styles['wca-lineaciones__wc-card--yellow'],
                )}
                aria-hidden
              />
            ) : showRedTopLeft ? (
              <span
                className={classNames(
                  styles['wca-lineaciones__wc-card'],
                  styles['wca-lineaciones__wc-card--red'],
                )}
                aria-hidden
              />
            ) : null}
          </div>
          <div
            className={classNames(
              styles['wca-lineaciones__m-player-iconSlot'],
              styles['wca-lineaciones__m-player-iconSlot--leftBottom'],
            )}
          >
            {showDiag2yBottom ? (
              <span
                className={classNames(
                  styles['wca-lineaciones__wc-card'],
                  styles['wca-lineaciones__wc-card--diag2y'],
                )}
                aria-hidden
              />
            ) : showRedBottomLeft ? (
              <span
                className={classNames(
                  styles['wca-lineaciones__wc-card'],
                  styles['wca-lineaciones__wc-card--red'],
                )}
                aria-hidden
              />
            ) : null}
          </div>
        </div>
        <div className={styles['wca-lineaciones__m-player-center']}>
          <PlaceholderAvatar
            photo={photo}
            className={classNames(styles['wca-lineaciones__m-avatar'], avatarTeamClass)}
          />
        </div>
        <div
          className={classNames(
            styles['wca-lineaciones__m-player-iconsCol'],
            styles['wca-lineaciones__m-player-iconsCol--right'],
          )}
        >
          <div
            className={classNames(
              styles['wca-lineaciones__m-player-iconSlot'],
              styles['wca-lineaciones__m-player-iconSlot--rightTop'],
            )}
          >
            {subOut ? (
              <img
                className={styles['wca-lineaciones__m-player-iconImg']}
                src={flechaAbajoUrl}
                alt=""
                width={12}
                height={12}
              />
            ) : null}
          </div>
          <div
            className={classNames(
              styles['wca-lineaciones__m-player-iconSlot'],
              styles['wca-lineaciones__m-player-iconSlot--rightBottom'],
            )}
          >
            {goal ? (
              <>
                <img
                  className={styles['wca-lineaciones__m-player-iconImg']}
                  src={balonUrl}
                  alt=""
                  width={12}
                  height={12}
                />
                {showGoalNumber ? (
                  <span className={styles['wca-lineaciones__m-player-goalN']}>{goalCount}</span>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>
      <span className={styles['wca-lineaciones__m-name']}>{lastName}</span>
    </div>
  );
}
